import React, { useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import PersonalDetailsModal from "../Common_profile_details_modals/PersonalDetailsModal/PersonalDetailsModal";

function PersonalDetailsCard() {
  const [showPersonalModal, setShowPersonalModal] = useState(false);
  return (
    <>
      <Card className="profile-card-pattern">
        <Card.Body className="profile-card-pattern__body">
          <div className="profile-card-pattern__header">
            <Card.Title className="profile-card-pattern__title">
              Personal details
            </Card.Title>
            <Button
              variant="link"
              className="profile-card-pattern__btn-edit"
              aria-label="Edit personal details"
              onClick={() => setShowPersonalModal(true)}
            >
              <span className="summary-card__edit-icon">✏️</span>
            </Button>
          </div>

          <Row className="g-3">
            <Col xs={12} md={4} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Equal Opportunity
              </span>
              <span className="profile-pattern-detail-cell__value">-</span>
            </Col>
            <Col xs={12} md={4} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Countries of Residency
              </span>
              <span className="profile-pattern-detail-cell__value">India</span>
            </Col>
            <Col xs={12} md={4} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Work Permit Countries
              </span>
              <span className="profile-pattern-detail-cell__value">-</span>
            </Col>
            <Col xs={12} md={4} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Nationality
              </span>
              <span className="profile-pattern-detail-cell__value">Indian</span>
            </Col>
            <Col xs={12} md={4} className="profile-pattern-detail-cell">
              <span className="profile-pattern-detail-cell__label">
                Specially Abled
              </span>
              <span className="profile-pattern-detail-cell__value">No</span>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <PersonalDetailsModal
        show={showPersonalModal}
        handleClose={() => setShowPersonalModal(false)}
      />
    </>
  );
}

export default PersonalDetailsCard;
